<div class='finance-awards-tab1-part'>
	This is the finance-awards tab 1
</div>